import Icon, {IconKind} from "@/lib/components/Icon";
import {FlexStyle, StyleSheet, Text, View} from "react-native";
import {Color} from "@/lib/styles";

type Props = {
    title: string,
    icon?: IconKind,
    marginTop?: number,
    marginBottom?: number,
    center?: boolean,
    size?: number,
}

export default function Header({icon, title, center, marginTop, marginBottom, size}: Props) {
    const height = size ? size : 16;

    const containerStyle = {
        marginTop: marginTop || 0,
        marginBottom: marginBottom || 0,
        minHeight: height + 4,
    }

    const centerStyle: FlexStyle = center ? {justifyContent: "center"} : {};

    const textStyle = {
        fontSize: height,
        lineHeight: height * 1.2,
    }

    return (
        <View style={[styles.container, containerStyle, centerStyle]}>
            {icon && <Icon kind={icon} size={size}/>}
            <Text style={[styles.text, textStyle]}>{title}</Text>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        gap: 8,
        alignItems: "center",
        justifyContent: "flex-start",
        minHeight: 24,
        //marginBottom: 8,
        width: "100%",
    },
    text: {
        color: Color.PrimaryText,
        fontWeight: 600,
    },
})